export enum PackageModulesEvent {
  OnRemoveCompetitorsSelect = 'onRemoveCompetitorsSelect',
}

export class OnRemoveCompetitorsSelect extends CustomEvent<{ isRemoveCompetitorsChecked: boolean }> {
  constructor(isRemoveCompetitorsChecked: boolean) {
    super(PackageModulesEvent.OnRemoveCompetitorsSelect, {
      detail: {
        isRemoveCompetitorsChecked,
      },
      bubbles: true,
      composed: true,
    });
  }
}
